<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Vigilancias')"
      :directory="$t('Listado')"
      :icon="'trello'"
    />

    <div class="row">
          <div class="col-sm-12 col-md-12">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button
              type="button"
              class="btn btn-primary btn-with-shadow mb-3"
              @click="
                () => {
                  $hub.$emit('reload-vigilance-list');
                }
              "
            >
              <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
            </button>
          </div>
        </div>
    </div>
    
    <div class="mb-primary">
      <app-table :id="tableId"  :options="options" @action="getListAction" />
    </div>

    <vigilance-modal
      v-if="isAddEditModalActive"
      :modalTitle="modalTitle"
      :editModalTitle="editModalTitle"
      :table-id="tableId"
      :msgInfo="msgInfo"
      :msgType="msgType"
      :msgNote="msgNote"
      :accAppReplicaId="accAppReplicaId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      modalId="vigilance-modal-start"
    />

  </div>
  
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  name: "TabAsign",
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      modalTitle: "Proceso vigilancia.",
      editModalTitle:  "Proceso vigilancia.",
      isAddEditModalActive: false,
      accAppReplicaId: Number,
      msgInfo: "",
      msgType: "",
      msgNote: "",
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "vigilance-list",
      rowData: {},
      options: {
        url: `${actions.VIGILANCES}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Iniciar proceso"),
            icon: "eye",
            type: "none",
            component: "vigilance-modal",
            modalId: "vigilance-modal-start",
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },


    closeAddEditModal() {
      $("#vigilance-modal-start").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("Iniciar proceso")) {
        this.selectedUrl = `${actions.VIGILANCES}/${rowData.id}`;
        this.accAppReplicaId = rowData.id;
        this.msgNote = 'Se enviará una notificación al OEC y al Gestor Técnico.';
        if (rowData.accreditation_type_id == 9) {
          this.$toastr.e("No tiene acceso para iniciar el proceso");
          return;
        } else {
          this.msgInfo = '¿Desea iniciar la '+ rowData.accreditation_type.name + " con código de expediente " + rowData.record + ' ?' ;
          if (rowData.accreditation_type.name.includes("Vigilancia")) {
            this.msgType = 'Vigilancia';
          }
          if (rowData.accreditation_type.name === "Renovación") {
            this.msgType = 'Renovación';
          }
          this.openAddEditModal();
        }
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

   
  },
};
</script>
